export const insertableCaseDetailTables = () => {
  return []
}

export default insertableCaseDetailTables
